import React, { useMemo } from "react";
import { useState } from "react";
import "../../utils/comman/Dashboard.css";
import { toast } from "react-toastify";
import moment from "moment";
import { useEffect } from "react";
import { useSelector } from "react-redux/es/exports";
import axiosinstances from "../../Helper/useAxios";
import {
  nopagepermission,
  requestLoading,
  utrLeng,
} from "../../utils/comman/Common";
import { tooltipStyle } from "../../utils/Constant";
import { Tooltip } from "react-tooltip";
import MidUISection from "./MidUISection";

import { useLocation } from "react-router-dom";
import { appVersion } from "../../version";

const Reporting = () => {
  const currentDate1 = moment();
  const todayDate = new Date();
  const location = useLocation();
  const mid = JSON.parse(sessionStorage.getItem("mid"));
  const formatDate = (date) => date.format("YYYY-MM-DD");
  const initialStartDate = new Date(todayDate);
  initialStartDate.setDate(todayDate.getDate() - 30);

  const accessPath = process.env.REACT_APP_accessPath;
  const [data, setData] = useState({});
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );
  const id = useSelector((state) => console.log("STATE1", state));
  // console.log("id", id);
  const e = JSON.parse(sessionStorage.getItem("token"));
  const [selectedRange, setSelectedRange] = useState("");
  const [startDate, setStartDate] = useState(
    formatDate(currentDate1.clone().startOf("month"))
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  ); // Default to today
  const [colorRange, setColorRange] = useState({
    max: 0,
    green: {},
    orange: {},
    yellow: {},
  });

  const [table, settable] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const bankList = process.env.REACT_APP_INDIANBANKS;
  var indianBanksJSON = JSON.parse(bankList);
  const storeData = useSelector(
    (state) => state?.configDetailsreducer?.details
  );

  const [warningShown, setWarningShown] = useState(false);
  const currentVersionfromApi =
    (Array.isArray(storeData) &&
      storeData.filter(
        (val) => val.id == "REACT_APP_QRBONPAY_MER_PORTAL_CUREENT_VERSION"
      )) ||
    [];
  useEffect(() => {
    if (
      appVersion &&
      Array.isArray(currentVersionfromApi) &&
      currentVersionfromApi.length > 0
    ) {
      const apiCurrentVersion = currentVersionfromApi[0]?.value;
      if (apiCurrentVersion !== appVersion && !warningShown) {
        toast.warn(
          `Kindly reload your application, a new version ${apiCurrentVersion} is available.`
        );
        setWarningShown(true); // Set the flag to prevent further warnings
      }
    }
  }, [currentVersionfromApi, appVersion, warningShown]);

  const handleRangeChange = (e) => {
    const range = e.target.value;
    console.log(range, range === "ONEMONTH");

    const currentDate = moment(); // Initialize currentDate as moment object

    let startDate, endDate;

    if (range === "ONEMONTH") {
      // Start date is the 1st of the current month
      startDate = currentDate.clone().startOf("month");

      // End date is today
      endDate = currentDate; // Just use the current moment as the end date
    } else if (range === "TWOMONTH") {
      // Start date is the 1st of the previous month
      startDate = currentDate.clone().subtract(1, "months").startOf("month");
      // End date is the last day of the previous month
      endDate = currentDate.clone().subtract(1, "months").endOf("month");
    } else if (range === "THREEMONTH") {
      // Start date is the 1st of the month before the previous month
      startDate = currentDate.clone().subtract(2, "months").startOf("month");
      // End date is the last day of the month before the previous month
      endDate = currentDate.clone().subtract(2, "months").endOf("month");
    }

    // Format dates as YYYY-MM-DD
    const formatDate = (date) => date.format("YYYY-MM-DD");

    console.log("Start Date:", formatDate(startDate));
    console.log("End Date:", formatDate(endDate));

    setStartDate(formatDate(startDate));
    setEndDate(formatDate(endDate));
    setSelectedRange(range);
  };
  const fetchListOfRetailer = async () => {
    let url = `/api/v1/upi/merchant/get?id=${mid}`;
    await axiosInstance
      .get(url, {
        headers,
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  };
  const fetcrtAccountList = async () => {
    setDataLoading(true);

    let url = `/api/v1/upi/reporting/table/all?fromDate=${startDate}&toDate=${endDate}&mid=${mid}`;

    const response = await axiosInstance
      .get(url, {
        headers,
      })
      .then((res) => {
        if (res !== undefined && res.status == 200) {
          settable(res.data);
          setDataLoading(false);
        }
      })
      .catch((err) => {
        //console.log(err);
        setDataLoading(false);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.transactions;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  useEffect(() => {
    if (selectedRange) {
      fetcrtAccountList();
    }
  }, [selectedRange]);
  useEffect(() => {
    fetcrtAccountList();
    fetchListOfRetailer();
  }, []);

  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };

  const showBankFullName = (val) => {
    const filterName =
      val !== ""
        ? indianBanksJSON.filter(
            (name) => name.value.toLowerCase() == val.toLowerCase()
          )
        : [];
    if (Array.isArray(filterName) && filterName.length > 0) {
      return filterName[0]?.label;
    }
    return val;
  };

  const handleColorRange = (max, green, orange, yellow) => {
    setColorRange({
      max: max,
      green: green,
      orange: orange,
      yellow: yellow,
    });
  };

  return (
    <div className="mid">
      <p
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
        This page is under maintenance.
      </p>
    </div>

    // <React.Fragment>
    //   {loading ? (
    //     requestLoading()
    //   ) : (
    //     <>
    //       <Tooltip id="statement-tooltip" style={tooltipStyle} effect="solid" />

    //       <MidUISection
    //         {...{
    //           selectedRange,
    //           handleRangeChange,
    //           colorRange,
    //           handleColorRange,
    //           table,

    //           dataLoading,
    //           isDataLoaded,
    //           showBankFullName,
    //           utrLeng,
    //           data,
    //         }}
    //       />
    //     </>
    //   )}
    // </React.Fragment>
  );
};

export default Reporting;
